var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn_s btn_white color_filter",class:{'off': !_vm.isSelected},on:{"click":_vm.action_SelectCode}},[_c('div',{staticClass:"color_circle",style:(_vm.style)}),_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }